import SetUpPaySuccessModal from './setup-pay-success-modal';

export default SetUpPaySuccessModal;
